module.exports = __webpack_public_path__ + "static/media/赞助商.0ce8a198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/awards/images/赞助商.jpg
// module id = 1196
// module chunks = 0